<template>
  <div id="data-list-list-view" class="data-list-container">
    <edit-user
      :isSidebarActive="showSidebar"
      :data="sidebarData"
      @closeSidebar="toggleSidebar"
      :profiles="profiles"
      :customerFunction="loadCustomer"
      :segmentFunction="loadSegment"
      :customers="customers"
      :segments="segments"
      :userFunction="loadUsers"
      :editEl="editEl"
    />
    <vs-table
      ref="table"
      v-model="selected"
      :max-items="itemsPerPage"
      search
      :data="users"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary" @click="addNewService">Nouvel utilisateur</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nom & Prénoms</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="type">Type</vs-th>
        <vs-th sort-key="is_actif">Status</vs-th>
        <vs-th sort-key="created_at">Créé le</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ tr.name + ' '+ tr.first_name }}</vs-td>
          <vs-td>{{ tr.email }}</vs-td>
          <vs-td>{{ tr.profile }}</vs-td>
          <vs-td>
            <vs-chip :color="tr.status ? 'primary' : 'danger'">{{ tr.status ? 'Actif' : 'Suspendu' }}</vs-chip>
          </vs-td>
          <vs-td>{{ tr.created_at }}</vs-td>
          <vs-td class="whitespace-no-wrap">
            <div class="flex">
              <vx-tooltip :text="tr.status ? 'Suspendre' : 'Activer'">
                <feather-icon v-if="connected != tr.id" @click="suspendOrActive(tr.id, tr.status ? 0 : 1, tr)"
                  :icon="tr.status ? 'LockIcon' : 'UnlockIcon'"
                  svgClasses="w-5 h-5 stroke-current"
                  class="mr-2 cursor-pointer"
                />
              </vx-tooltip>
              <vx-tooltip text="Modifier">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                  @click="edit(tr)"
                />
              </vx-tooltip>
              <vx-tooltip text="Supprimer">
                <feather-icon @click="deleteUser(tr)"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                />
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
  </div>
</template>

<script>
  import EditUser from "./EditUser";

  export default {
    components: {EditUser},
    data() {
      return {
        itemsPerPage: 8,
        isMounted: false,
        selected: [],
        sidebarData: {},
        showSidebar: false,
        users: [],
        last_page: null,
        page: 1,
        profiles: [],
        customers: [],
        segments: [],
        editEl: false,
        connected: ''
      }
    },
    watch: {
      page(value) {
        this.loadUsers(value);
      },
    },
    mounted() {
      this.isMounted = true;
      this.loadUsers(this.page)
      this.connected = window.GETCCMT.$store.state.AppActiveUser.id
    },
    methods: {
      toggleSidebar(val = false) {
        this.showSidebar = val;
      },
      addNewService() {
        this.sidebarData = {};
        this.loadProfile()
        this.toggleSidebar(true);
      },
      edit(data) {
        this.editEl = true
        this.sidebarData = data;
        this.loadProfile()
        this.toggleSidebar(true);
      },
      loadUsers(page) {
        this.$vs.loading()
        this.$http.get('/users?page=' + page + '&paginate=1').then((response) => {
          this.users = response.data.data
          this.last_page = response.data.last_page
          this.$vs.loading.close()
        }).catch((error) => {
          console.log(error)
          this.$vs.loading.close()
        })
      },
      loadProfile(){
        this.$vs.loading()
        this.$http.get('/users/profile').then((response) => {
          this.profiles = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          console.log(error)
          this.$vs.loading.close()
        })
      },
      loadCustomer(){
        this.$vs.loading()
        this.$http.get('/customers').then((response) => {
          this.customers = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          console.log(error)
          this.$vs.loading.close()
        })
      },
      loadSegment(){
        this.$vs.loading()
        this.$http.get('/segments').then((response) => {
          this.segments = response.data
          this.$vs.loading.close()
        }).catch((error) => {
          console.log(error)
          this.$vs.loading.close()
        })
      },
      suspendOrActive(id, state, tr){
        if (state === 0){
          if (confirm('Voulez vous suspendre l\'utilisateur ?')){
            this.$vs.loading()
            this.$http.post('/users/suspend',
              {id: id, state: state, customer: tr.customer_id, profile: tr.profile_id}
              ).then(() => {
              this.$vs.loading.close()
              this.loadUsers(this.page)
            }).catch((error) => {
              console.log(error)
              this.$vs.loading.close()
            })
          }
        }else {
          if (confirm('Voulez vous activer l\'utilisateur ?')){
            this.$vs.loading()
            this.$http.post('/users/suspend',
              {id: id, state: state, customer: tr.customer_id, profile: tr.profile_id}
              ).then((re) => {
              if (!re.data.status){
                window.GETCCMT.error({ message: "Cette opération ne peut être effectué car le compte masteur est suspendu" });
              }else this.loadUsers(this.page)
              this.$vs.loading.close()
            }).catch((error) => {
              console.log(error)
              this.$vs.loading.close()
            })
          }
        }
      },
      deleteUser(tr){
        if (confirm('Voulez vous supprimer l\'utilisateur ?')){
          this.$vs.loading()
          this.$http.post('/users/delete',
            {id: tr.id, customer: tr.customer_id, profile: tr.profile_id}
          ).then((re) => {
            if (!re.data.status){
              window.GETCCMT.error({ message: "Une erreur est survenu lors de l'opération" });
            }else {
              let index = this.users.indexOf(tr)
              this.users.splice(index, 1)
            }
            this.$vs.loading.close()
          }).catch((error) => {
            console.log(error)
            this.$vs.loading.close()
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 0.5rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: 0.5rem;
              border-bottom-left-radius: 0.5rem;
            }

            &:last-child {
              border-top-right-radius: 0.5rem;
              border-bottom-right-radius: 0.5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
